
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20","viewBox":"0 0 18 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EFEFEA","d":"M15.9 2.2h-1v-2h-2v2H5.1v-2h-2v2h-1c-1.1 0-2 .9-2 2v13.7c0 1.1.9 2 2 2h13.7c1.1 0 2-.9 2-2V4.1c0-1.1-.9-1.9-1.9-1.9zM9 5.1c1.6 0 2.9 1.3 2.9 2.9s-1.3 3-2.9 3-2.9-1.3-2.9-3S7.4 5.1 9 5.1zm5.9 11.8H3.1v-1c0-2 3.9-3 5.9-3s5.9 1.1 5.9 3v1z"}})])
          )
        }
      }
    